/* Pansite wenslijst — bewaart favorieten in de browser (localStorage), zonder account. */
(function () {
  'use strict';
  if (window.PsnWishlist) return;

  var KEY = 'psn-wenslijst-v1';
  var MAX = 60;
  var PAGE_URL = '/pages/wenslijst';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (i) { return i && typeof i.h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('psn-wishlist:change', { detail: { handles: handles() } }));
  }
  function handles() { return read().map(function (i) { return i.h; }); }
  function has(h) { return handles().indexOf(h) > -1; }
  function add(h) { if (!h || has(h)) return; var l = read(); l.unshift({ h: h, t: Date.now() }); write(l); }
  function remove(h) { write(read().filter(function (i) { return i.h !== h; })); }
  function toggle(h) { if (has(h)) { remove(h); return false; } add(h); return true; }
  function clear() { write([]); }

  /* ---------- Hartjes en teller bijwerken ---------- */
  function sync() {
    var list = handles();
    document.querySelectorAll('[data-psn-wl-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-psn-wl-toggle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-psn-wl-label]');
      var txt = on ? 'Bewaard in je wenslijst' : 'Bewaar in wenslijst';
      if (label) { if (label.textContent !== txt) label.textContent = txt; }
      else btn.setAttribute('aria-label', on ? 'Verwijder uit wenslijst' : 'Bewaar in wenslijst');
    });
    document.querySelectorAll('[data-psn-wl-count]').forEach(function (el) {
      var n = String(list.length);
      if (el.textContent !== n) el.textContent = n; // alleen bij wijziging, anders blijft de observer afgaan
      el.hidden = list.length === 0;
    });
  }

  /* ---------- Melding onderin ---------- */
  var toastTimer;
  function toast(added) {
    var t = document.getElementById('psn-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'psn-wl-toast';
      t.className = 'psn-wl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    var n = handles().length;
    t.innerHTML = added
      ? '<span class="psn-wl-toast__heart" aria-hidden="true">' + heartSvg(true) + '</span><span>Bewaard in je wenslijst</span>' +
        '<a href="' + PAGE_URL + '">' + (n > 1 ? 'Vergelijk ' + n + ' sieraden' : 'Bekijk') + ' →</a>'
      : '<span>Verwijderd uit je wenslijst</span>';
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3800);
  }

  function heartSvg(filled) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" focusable="false" aria-hidden="true"><path d="M12 20.6s-7.6-4.7-9.4-9.3C1.4 8.2 3.3 4.8 6.6 4.5c2-.2 3.6.9 4.5 2.4.2.3.6.3.8 0 .9-1.5 2.5-2.6 4.5-2.4 3.3.3 5.2 3.7 4 6.8-1.8 4.6-9.4 9.3-9.4 9.3z" fill="' + (filled ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  }

  /* ---------- Klik op een hartje ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-psn-wl-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-psn-wl-toggle'));
    btn.classList.remove('psn-wl-pop');
    void btn.offsetWidth;
    if (added) btn.classList.add('psn-wl-pop');
    toast(added);
    try { (window.dataLayer = window.dataLayer || []).push({ event: added ? 'add_to_wishlist' : 'remove_from_wishlist', wishlist_item: btn.getAttribute('data-psn-wl-toggle') }); } catch (err) {}
  }, true);

  /* ---------- Productpagina: knop onder de koopknoppen ---------- */
  function heartButton(h) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'psn-wl-heart';
    btn.setAttribute('data-psn-wl-toggle', h);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Bewaar in wenslijst');
    btn.innerHTML = heartSvg(false) + heartSvg(true);
    return btn;
  }

  /* ---------- Productkaarten van het thema ---------- */
  function injectCards() {
    document.querySelectorAll('product-card[handle]:not([data-psn-wl])').forEach(function (card) {
      card.setAttribute('data-psn-wl', '1');
      var fig = card.querySelector('.product-card__figure');
      if (fig) fig.appendChild(heartButton(card.getAttribute('handle')));
    });
  }

  /* ---------- Header: hartje met teller naast de winkelwagen ---------- */
  function injectHeader() {
    document.querySelectorAll('.header__cart-link').forEach(function (cart) {
      var ul = cart.parentNode;
      if (!ul || ul.querySelector('.header__wishlist-link')) return;
      var li = document.createElement('li');
      li.className = 'relative header__wishlist-link';
      li.innerHTML = '<a href="' + PAGE_URL + '" aria-label="Mijn wenslijst">' + heartSvg(false).replace('<svg ', '<svg class="header__nav-icon" ') +
        '<span class="psn-wl-badge" data-psn-wl-count hidden>0</span></a>';
      ul.insertBefore(li, cart);
    });
  }

  function injectProductButton() {
    var h = window.PSN_WL_PRODUCT;
    if (!h || document.querySelector('.psn-wl-product-btn')) return;
    var scope = document.querySelector('.product-info') || document.querySelector('product-rerender') || document;
    var anchor = scope.querySelector('.buy-buttons') || scope.querySelector('buy-buttons') ||
      scope.querySelector('form[action*="/cart/add"]');
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.className = 'psn-wl-product';
    wrap.innerHTML =
      '<button type="button" class="psn-wl-product-btn" data-psn-wl-toggle="' + h.replace(/"/g, '') + '">' +
        heartSvg(false) + '<span data-psn-wl-label>Bewaar in wenslijst</span></button>' +
      '<a class="psn-wl-product__link" href="' + PAGE_URL + '">Mijn wenslijst <span class="psn-wl-badge" data-psn-wl-count hidden>0</span></a>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    sync();
  }

  /* ---------- Searchanise-resultaten: hartje toevoegen ---------- */
  function injectSearchanise(root) {
    (root || document).querySelectorAll('.snize-product:not([data-psn-wl])').forEach(function (card) {
      card.setAttribute('data-psn-wl', '1');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var holder = card.querySelector('.snize-thumbnail-wrapper, .snize-thumbnail') || card;
      if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
      holder.appendChild(heartButton(decodeURIComponent(m[1])));
    });
  }

  function injectAll() {
    injectHeader();
    injectCards();
    injectProductButton();
    injectSearchanise();
    sync();
  }

  function init() {
    injectAll();
    var pending;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          clearTimeout(pending);
          pending = setTimeout(injectAll, 80);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  window.PsnWishlist = { handles: handles, has: has, add: add, remove: remove, toggle: toggle, clear: clear, sync: sync, heartSvg: heartSvg, pageUrl: PAGE_URL };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
